export const skillsCategories = [
    {
        key: 'regulatory',
        title: 'Regulatory Skills',
        color: '#d9f9d9',
        skills: [
            { key: '107', label: 'FAA Part 107' },
            { key: 'aroc', label: 'AROC (Aeronautical Radio Operator Certificate)' },
        ],
    },
    {
        key: 'operational',
        title: 'Operational Skills',
        color: '#d9f9d9',
        skills: [
            { key: 'remote_pic', label: 'Remote PIC' },
            { key: 'vo', label: 'VO (Visual Observer)' },
            { key: 'battery', label: 'Battery Management' },
            { key: 'payload', label: 'Payload Management' },
            { key: 'planning', label: 'Flight Path Planning' },
        ],
    },
    {
        key: 'technology',
        title: 'Technology Skills',
        color: '#d9f9d9',
        skills: [
            { key: 'dronedeploy', label: 'DroneDeploy' },
            { key: 'droneharmony', label: 'DroneHarmony' },
            { key: 'flybase', label: 'Flybase' },
            { key: 'pix4d', label: 'Pix4D Capture' },
            { key: 'dji_pilot', label: 'DJI Pilot' },
            { key: 'dji_terra', label: 'DJI Terra' },
            { key: 'dji_modify', label: 'DJI Modify' },
        ],
    },
    {
        key: 'use_cases',
        title: 'Industry Use Case Skills',
        color: '#d9f9d9',
        skills: [
            { key: 'aerial_survey', label: 'Aerial Survey' },
            { key: 'asset_inspection', label: 'Asset Inspection' },
            { key: 'crop_health', label: 'Crop Health Survey' },
            { key: 'photogrammetry', label: 'Photogrammetry' },
            { key: 'lidar', label: 'Lidar' },
            { key: 'real_estate', label: 'Real Estate' },
            { key: 'roof_inspection', label: 'Roof Inspection' },
            { key: 'solar_farm', label: 'Solar Farm Inspection' },
            { key: 'videography', label: 'Videography' },
        ],
    },
    {
        key: 'environmental',
        title: 'Environmental Skills',
        color: '#d9f9d9',
        skills: [
            { key: 'bvloss', label: 'BVLOSS' },
            { key: 'evloss', label: 'EVLOSS' },
            { key: 'adverse_weather', label: 'Rain Flight → Adverse Weather Operations' },
            { key: 'low_light', label: 'Night Flight → Low-Light Operations' },
            { key: 'operations_people', label: 'Operations over People' },
        ],
    },
];